"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var _Item = _interopRequireDefault(require("../../Item.styles"));

var bool = _propTypes["default"].bool,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes = {
  /** HTML for each item */
  children: node.isRequired,

  /** If the item is destructive. */
  isDestructive: bool,

  /** Callback to be executed when button is clicked */
  onClick: func,

  /** Callback to be executed when key is pressed */
  onKeyDown: func,

  /** Callback to be executed when overflow menu needs to be closed */
  onClose: func,

  /** Callback to be executed when delete item is clicked */
  onShowConfirmation: func,

  /** Render prop to render the replacement node */
  renderConfirmation: func
};
var defaultProps = {
  isDestructive: false,
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  onClose: function onClose() {},
  onShowConfirmation: function onShowConfirmation() {},
  renderConfirmation: null
};

var _StyledRawButton = (0, _styledComponents["default"])(_rawButton["default"]).withConfig({
  displayName: "Item___StyledRawButton",
  componentId: "fx5h55-0"
})(["", ""], _Item["default"]);

var Item = function Item(props) {
  var children = props.children,
      isDestructive = props.isDestructive,
      onClick = props.onClick,
      onClose = props.onClose,
      onShowConfirmation = props.onShowConfirmation,
      renderConfirmation = props.renderConfirmation,
      onKeyDown = props.onKeyDown,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["children", "isDestructive", "onClick", "onClose", "onShowConfirmation", "renderConfirmation", "onKeyDown"]);

  var handleClickItem = function handleClickItem() {
    onClick(children);
    onClose();
  };

  var itemProps = {
    canPropagate: false,
    "data-pka-anchor": "overflow-menu.item",
    hasInsetFocusStyle: true,
    isDestructive: isDestructive,
    onClick: renderConfirmation !== null ? onShowConfirmation : handleClickItem,
    onKeyDown: onKeyDown,
    role: "menuitem",
    tabIndex: 0
  };
  return /*#__PURE__*/_react["default"].createElement(_StyledRawButton, (0, _extends2["default"])({}, itemProps, moreProps), children);
};

Item.displayName = "OverflowMenu.Item";
Item.propTypes = propTypes;
Item.defaultProps = defaultProps;
var _default = Item;
exports["default"] = _default;
//# sourceMappingURL=Item.js.map